export default "__VITE_ASSET__Bl05eTvj__"